import { Input } from 'antd';
import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { handleError } from 'utils/component.util';

const { TextArea } = Input;

type InputType = UseControllerProps & {
  title: string;
  type?: string;
  className?: string;
  placeholder?: string;
  rtl?: boolean;
  textArea?: boolean;
  inputStyle?: string;
  autoComplete?: string;
};
const FormInput: React.FC<InputType> = (props) => {
  const {
    field,
    fieldState: { error },
  } = useController(props);

  return (
    <div className={`relative ${props.className}`}>
      <div
        className={`absolute top-[-10px] right-[12px] bg-white px-[6px] z-10 text-[11px] ${
          error && 'text-red-0'
        }`}
      >
        {props.title}
      </div>
      {props.textArea ? (
        <TextArea
          {...field}
          status={error && 'error'}
          size="large"
          className={props.rtl ? 'toLeft' : 'toRight'}
        />
      ) : (
        <Input
          {...field}
          autoComplete={props.autoComplete}
          status={error && 'error'}
          type={props.type}
          size="large"
          placeholder={props.placeholder}
          className={(!props.rtl ? 'toRight' : '') + props.inputStyle} // eslint-disable-line
        />
      )}
      <div>{handleError(error, props.rules)}</div>
    </div>
  );
};

export default FormInput;
